import cn from 'classnames';
import SpinnerLoading from '../SpinnerLoading';

interface IProps {
  className?: string;
  loaderSize?: number;
}

const PageLoader = ({className, loaderSize = 50}: IProps) => {
  return (
    <div
      className={cn(
        'h-dvh flex justify-center items-center w-screen',
        className,
      )}
    >
      <SpinnerLoading size={loaderSize} />
    </div>
  );
};

export default PageLoader;
